import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import { useTheme } from "../context/ThemeContext";

function NtDevider({ containerStyle }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return <View style={[styles.container, containerStyle]} />;
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      width: "100%",
      height: 1,
      backgroundColor: t.borderSoft,
    },
  });

export default NtDevider;
